import React, { useEffect, useState } from "react";
import styles from "./InfoCard.module.css";

import NoAttach1 from "../../../assets/Imagess/NoAttach1.svg";
import NoAttach2 from "../../../assets/Imagess/NoAttach2.svg";
import greenChecked from "../../../assets/Imagess/greenChecked.svg";

const UsersTable = ({
  arrayIdx,
  title,
  answers,
  width = "",
  type,
  percentages = [],
}) => {
  useEffect(() => {}, []);
  let titleWords = title.split(" ");

  return (
    <div className={`${styles["card-container"]} ${styles[width]}`}>
      {title ? (
        <div className={`${styles["row"]}`}>
          <div className={`${styles["w-100"]}`}>
            <h6 className={`${styles["title"]}`}>
              {titleWords &&
                titleWords.map((item, index) => (
                  <span
                    className={`${
                      (arrayIdx === 0 && item === "relevant") ||
                      (arrayIdx === 1 && item === "interest") ||
                      (arrayIdx === 2 && item === "believe") ||
                      (arrayIdx === 3 && item === "value") ||
                      (arrayIdx === 4 && item === "relevant")
                        ? styles["specialTitle"]
                        : styles["title"]
                    }`}
                  >
                    {item + " "}
                  </span>
                ))}
            </h6>
          </div>
        </div>
      ) : null}

      <div className={`${styles["row"]}`}>
        <div className={`${styles["w-100"]}`}>
          {!type &&
            answers.map((item, i) => (
              <h6 key={i}>
                <span className={`${styles["subTitle"]}`}>
                  {i === 0
                    ? "A. "
                    : i === 1
                    ? "B. "
                    : i === 2
                    ? "C. "
                    : i === 3
                    ? "D. "
                    : "E. "}{" "}
                  {item}
                </span>{" "}
                <span className={`${styles["Percentage"]}`}>
                  {" "}
                  {percentages[i]}%{" "}
                </span>
              </h6>
            ))}

          {type === 1 &&
            answers.map(
              (item, i) =>
                item && (
                  <h6 key={i}>
                    <img src={greenChecked} className={`  `} />{" "}
                    <span className={`${styles["subTitle"]}`}>{item}</span>{" "}
                  </h6>
                )
            )}

          {type === 2 &&
            answers.map(
              (item, i) =>
                item && (
                  <h6 key={i}>
                    <img src={greenChecked} className={`  `} />{" "}
                    <span className={`${styles["subTitle"]}`}>
                      {i === 0
                        ? "A. "
                        : i === 1
                        ? "B. "
                        : i === 2
                        ? "C. "
                        : i === 3
                        ? "D. "
                        : "E. "}
                      {item.charAt(0).toUpperCase() + item.slice(1)}
                    </span>{" "}
                  </h6>
                )
            )}
        </div>
      </div>
    </div>
  );
};

export default UsersTable;
